/**
 * Builds the base WebSocket URL (without a channel path). On-premise deployments
 * connect to the appliance host on the configured backend port; cloud uses the
 * configured public WS URL.
 */
export var getWebsocketUrl = function getWebsocketUrl() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;
  var cloudUrl = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_WS_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "";
  if (typeof window === "undefined") return cloudUrl;
  var isOnPremise = process.env.NEXT_PUBLIC_IS_ONPREMISE === "true";
  if (!isOnPremise) return cloudUrl;
  var hostname = window.location.hostname;
  var port = (_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_ONPREMISE_BACKEND_PORT) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "";
  return "ws://".concat(hostname, ":").concat(port, "/ws");
};